//constants
import {
	DELETE_UPPER,
	DETAILS,
	CHECK_IN,
	PENDING,
	CATEGORIES,
	ALL_CATEGORIES,
	ACTIVITY,
	AUCTION,
} from '@/utils/constants';
import {AUCTION_BIDS_ACTIVITY, AUCTION_TYPE} from '@/utils/enums';
//helpers
import {camelize} from '@/utils/helpers';
//types
import {IFilterGroup, IOrganizationAuctionCategory} from '@/utils/types';

export const tableAttendeesMenuContent = [DETAILS, PENDING, CHECK_IN, DELETE_UPPER];

export const attendeeBidsDefaultFilterValues = {
	sortColumn: '',
	isOrderDesc: false,
	activity: camelize(AUCTION_BIDS_ACTIVITY.ALL_BIDS),
	auctionType: camelize(AUCTION_TYPE.ALL_ITEMS),
	categoryIds: null,
};

export const attendeeBidsDefaultFilterData: IFilterGroup[] = [
	{
		title: ACTIVITY,
		options: [
			{title: AUCTION_BIDS_ACTIVITY.ALL_BIDS, isSelected: true},
			{title: AUCTION_BIDS_ACTIVITY.WON, isSelected: false},
		],
	},
	{
		title: AUCTION,
		options: [
			{title: AUCTION_TYPE.ALL_ITEMS, isSelected: true},
			{title: AUCTION_TYPE.SILENT, isSelected: false},
			{title: AUCTION_TYPE.LIVE, isSelected: false},
		],
	},
	{
		title: CATEGORIES,
		options: [{title: ALL_CATEGORIES, isSelected: true, id: null}],
	},
];

export const updatedAttendeeBidsFilterOptions = (
	auctionCategories: IOrganizationAuctionCategory[],
	filterData: IFilterGroup[]
) =>
	filterData.map((filterGroup) =>
		filterGroup.title === CATEGORIES
			? {
					...filterGroup,
					options: [
						{
							title: ALL_CATEGORIES,
							isSelected: !filterGroup.options.every((option) => !option.isSelected && option.id === null),
							id: null,
							isCheckBox: false,
						},
						...auctionCategories.map((tier) => ({title: tier.name, isSelected: false, id: tier.id, isCheckBox: true})),
					],
			  }
			: filterGroup
	);

export const handleSetCategoryIds = (currentTierIds: number[] | null, id?: number) => {
	if (!id) return null;

	const isIdInTierIds = currentTierIds ? currentTierIds.includes(id) : false;

	if (isIdInTierIds) {
		const newTierIds = currentTierIds?.filter((tierId) => tierId !== id) || [];
		return newTierIds.length > 0 ? newTierIds : null;
	}
	return [...(currentTierIds || []), id];
};

export const getUpdatedFilterData = (
	currentFilterData: IFilterGroup[],
	groupTitle: string,
	optionTitle: string,
	selectedCheckboxId?: number | null
) => {
	const indexToUpdate = currentFilterData.findIndex((filterGroup) => filterGroup.title === groupTitle);

	return currentFilterData.map((filterGroup, index) => {
		if (index !== indexToUpdate) return filterGroup;

		switch (groupTitle) {
			case ACTIVITY:
			case AUCTION:
				return {
					...filterGroup,
					options: filterGroup.options.map((option) => ({
						...option,
						isSelected: option.title === optionTitle,
					})),
				};

			case CATEGORIES:
				const newOptions = filterGroup.options.map((option) => {
					if (option.isCheckBox && option.id === selectedCheckboxId) {
						return {
							...option,
							isSelected: !option.isSelected,
						};
					}
					return {
						...option,
					};
				});

				const hasSelectedCheckBox = newOptions.some((option) => option.isCheckBox && option.isSelected);

				const updatedOptions = newOptions.map((option) => {
					if ((!option.isCheckBox && hasSelectedCheckBox) || (option.isCheckBox && !hasSelectedCheckBox)) {
						return {
							...option,
							isSelected: false,
						};
					}

					if (!option.isCheckBox && !hasSelectedCheckBox) {
						return {
							...option,
							isSelected: true,
						};
					}

					return option;
				});

				return {
					...filterGroup,
					options: updatedOptions,
				};

			default:
				return filterGroup;
		}
	});
};
